const enum SliceNames {
	BRAND = 'brandSlice',
	ICONS = 'iconsSlice',
	NAVIGATION = 'navigationSlice',
	WINDOW = 'windowSlice',
	EXPOSER = 'exposerSlice',
	REF = 'refSlice',
	OPTIONS = 'optionsSlice',
	SAVED_BUILDS = 'savedBuildsSlice',
	SECONDARY_NAV = 'secondaryNavSlice',
}

export default SliceNames;
